module.exports = "<div layout-fill ui-view flex class=\"f-feiseanna-one f-feis-details\"></div>"


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/tpl.html
// module id = 1231
// module chunks = 0